export function getPrefixNumberFromString(value: string) {
  const match = /\d+/.exec(value);
  return match ? match[0] : null;
}
